import PermitCustomAgreementPage from "./permitCustomAgreement";

export default PermitCustomAgreementPage;